var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"steps-component"},[_c('div',{staticClass:"line-through"}),_c('ul',_vm._l((_vm.items),function(item,index){return _c('li',{key:item.key,class:{'current-step': _vm.current >= index + 1}},[_c('span',{staticClass:"index"},[_vm._v(_vm._s(index + 1))]),_c('span',{staticClass:"name"},[_vm._v(_vm._s(item.name))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }